var $156880e329b1c717$exports = {};
$156880e329b1c717$exports = {
  "removeButtonLabel": "Remover",
  "removeDescription": "Pressione Delete para remover a tag."
};
export { $156880e329b1c717$exports as default };